export default __webpack_public_path__ + "static/media/scales-icon.b67d1ac5.svg";